export function removeEmptyRunStatusFilter(event) {
    if (!event.detail.elt.matches?.('.run-detail .filter-bar')) {
        return;
    }

    if (event.detail.parameters.status === '') {
        delete event.detail.parameters.status;
    }
}
